$( document ).ready(init());

function init()
{
    var socialSharingLinks = function(facebookBtn, twitterBtn)
    {

        var openShareWindow = function(elem, href)
        {
            var w = $(window);
            javascript: window.open(
                href.replace('ENCODED_URL', encodeURIComponent(elem.data('url'))),
                '',
                'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=' + Math.min(w.height(), 450) + ',width=' + Math.min(w.width(), 600)
            );
        };

        const
            body = $('body'),
            isArchive = (body.hasClass('home') || body.hasClass('category')),
            parentOne = (isArchive ? '.row' : '.post'),
            parentTwo = (isArchive ? '.col-sm-9 > h2 > a' : 'h1')
        ;

        $(facebookBtn).click(function(e)
        {
            e.preventDefault();
            var clicked = $(this);
            
            var text = clicked.data('title').substring(
                0,
                136 - clicked.data("url").length
            );
            
            openShareWindow(clicked, "https://www.facebook.com/sharer/sharer.php?u=ENCODED_URL&t=" + encodeURIComponent(text));
        });
        
        $(twitterBtn).click(function(e)
        {
            e.preventDefault();
            var clicked = $(this);
            
            var text = clicked.data('title').substring(
                0,
                136 - clicked.data("url").length
            );
            
            openShareWindow(clicked, 'https://twitter.com/share?url=ENCODED_URL&text=' + encodeURIComponent(text + '...'));

        });
    };

    jQuery(".navbar-toggle").on("click", function () {
        jQuery(this).toggleClass("active");
        jQuery('html').toggleClass('mobile-nav-open');
    });

    socialSharingLinks('.btn-facebook a', '.btn-twitter a');

}
